<span class="app-bar-title-content">{{title}}</span>